import React, { useEffect, useState } from 'react';
import SIdebar from './SIdebar';
import videosData from '../Data/videos';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Pagination from 'react-js-pagination';
import { useLocation } from 'react-router-dom';


const Videos = () => {
  const location = useLocation()
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 8;
  const totalItemsCount = videosData.length;
  const pageRangeDisplayed = 5;

  const sortedVideos = videosData.sort((a, b) =>
    a.title.toLowerCase().localeCompare(b.title.toLowerCase())
  );

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const renderVideoCards = () => {
    return sortedVideos
      .slice((activePage - 1) * itemsPerPage, activePage * itemsPerPage)
      .map((video) => (
        <div className="card" style={{ width: '18rem' }} key={video.id}>
          <video
            controls
            className="card-img-top"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <source src={video.video} type='video/webm' />
          </video>
          <div className="card-body" data-aos="fade-down">
            <h5 className="w3-tag w3-teal card-title">{video.title}</h5>
          </div>
        </div>
      ));
  };

  return (
    <div>
      <SIdebar local={location.pathname}/>
      <h1 className='w3-container w3-teal project'>VIDEOS</h1>
      <div className='projetos'>{renderVideoCards()}</div>
      <h4 className='w3-bar w3-xlarge'>
        {totalItemsCount > itemsPerPage ? (
          <Pagination
            className='pagination'
            activePage={activePage}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={pageRangeDisplayed}
            onChange={handlePageChange}
          />
        ) : null}
      </h4>
      <h4>Copyright &copy; 2023</h4>
    </div>
  );
};

export default Videos;
